var _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNotificationsFill = function SvgNotificationsFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23,
    height: 23,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("mask", {
    id: "notifications_fill_svg__a",
    width: 23,
    height: 23,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D9D9D9",
    d: "M0 0h23v23H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#notifications_fill_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "current",
    d: "M5.031 18.097a.7.7 0 0 1-.512-.206.7.7 0 0 1-.207-.513q0-.305.207-.512a.7.7 0 0 1 .512-.206h1.014V9.51q0-1.935 1.193-3.42a5.3 5.3 0 0 1 3.064-1.9v-.597q0-.498.35-.848.348-.35.847-.35.498 0 .849.35.35.35.35.848v.598a5.3 5.3 0 0 1 3.064 1.9q1.193 1.486 1.193 3.418v7.15h1.014q.305 0 .512.208a.7.7 0 0 1 .206.512.7.7 0 0 1-.206.512.7.7 0 0 1-.512.206zm6.467 2.691q-.714 0-1.223-.509a1.67 1.67 0 0 1-.507-1.223h3.464q0 .717-.509 1.224-.51.508-1.225.508"
  }))));
};
export default SvgNotificationsFill;